import { Typography } from "antd";
import "./object-members-empty.scss";

const { Title } = Typography;

export const ObjectMembersEmpty = () => {
  return (
    <div className="table-container">
      <Title level={5} style={{ color: "#333333", fontSize: "20px" }}>
        Участники строительства объекта
      </Title>
      <div className="object-members-empty__description">
        Участники не добавлены.
        <br />
        Наполнение раздела происходит автоматически из данных Титульного листа
        Общего журнала работ.
      </div>
    </div>
  );
};
